import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import LogRocket from 'logrocket';
import { selectAccountInfo, setAccountInfo } from '~/store/accountInfo';
import { selectLogRocketId } from '~/store/env';

export const effect = createListenerEffect(
  'identifyLogRocket<Listener>',
  async (action, { dispatch, getState, take, trigger }) => {
    await take((_, state) => selectLogRocketId(state));

    const { userId, userName, email } = selectAccountInfo(getState());

    LogRocket.identify(userId, {
      name: userName,
      email,
      location: JSON.parse(sessionStorage.getItem('globalUserData'))?.principal?.location || '',
    });
  }
);

export const predicate = (action) => action.type === setAccountInfo.type && action.payload.userId;

const { startListening, middleware } = createListenerMiddleware();

startListening({
  predicate,
  effect,
});

export default middleware;
